module.exports = __webpack_public_path__ + "static/media/background-pagamentos3.377cb6a5.jpg";